export default function paymentAgreementBlockerFromError(error) {
  const data = error && error.response && error.response.data

  if (!data || data.error_code !== 'payment_agreement_verification_required') {
    return null
  }

  return {
    message: data.message || '',
    ctaLabel: data.cta_label || '',
    dismissLabel: data.dismiss_label || '',
    ctaHref: data.cta_href || '',
    showCta: data.show_cta !== false,
  }
}
